module.exports = __webpack_public_path__ + "static/scale-model-of-anno-domini-gallery-in-san-jose-california-b1b77b23382cbc120e962dcdeed1a05c.png";